module.exports = __webpack_public_path__ + "static/media/avatars_male_2.888ae8ff.png";